document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.mm-product-image-slider')

  sliders.forEach((slider) => {
    const track = slider.querySelector('.mm-product-image-slider__track')
    const prev = slider.querySelector('.mm-product-image-slider__arrow--prev')
    const next = slider.querySelector('.mm-product-image-slider__arrow--next')

    if (!track || !prev || !next) return

    const scrollToSlide = (direction) => {
      const slideWidth = track.clientWidth

      track.scrollBy({
        left: direction * slideWidth,
        behavior: 'smooth',
      })
    }

    prev.addEventListener('click', () => scrollToSlide(-1))
    next.addEventListener('click', () => scrollToSlide(1))
  })
})

document.addEventListener('change', (event) => {
  const input = event.target

  if (!input.matches('variant-selects input[type="radio"]')) return
  if (!input.name.includes('Color')) return

  const colorHandle = input.value
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')

  const mapScript = document.querySelector('#ProductColorMediaMap')
  if (!mapScript) return

  let mediaMap

  try {
    mediaMap = JSON.parse(mapScript.textContent)
  } catch (error) {
    console.error('ProductColorMediaMap JSON error:', error)
    return
  }

  const media = mediaMap[colorHandle]
  if (!media?.src) {
    console.warn('No media for color:', colorHandle, mediaMap)
    return
  }

  const mainImage =
    [...document.querySelectorAll('.product-images-slider .main_slider_img')]
      .find((img) => img.offsetParent !== null) ||
    document.querySelector('.product-images-slider .main_slider_img')

  if (!mainImage) return

  mainImage.src = media.src
  mainImage.srcset = media.srcset || ''
})

function formatMoney(cents) {
  if (window.Shopify?.formatMoney && window.mmMoneyFormat) {
    return window.Shopify.formatMoney(cents, window.mmMoneyFormat)
  }

  return `$${(cents / 100).toFixed(2)}`
}

const productJsonCache = {}

async function getSelectedProductJson(productUrl) {
  if (!productUrl) return null

  const url = `${productUrl}.js`

  if (productJsonCache[url]) return productJsonCache[url]

  const response = await fetch(url)
  if (!response.ok) return null

  const productJson = await response.json()
  productJsonCache[url] = productJson

  return productJson
}

function handleize(value) {
  return value
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

document.addEventListener('change', async (event) => {
  const input = event.target

  if (!input.matches('variant-selects input[type="radio"]')) return

  const selectedColorInput = document.querySelector('input[name="Color-1"]:checked')
  const selectedSize = document.querySelector('input[name="Size-2"]:checked')?.value

  if (!selectedColorInput || !selectedSize) return

  const productUrl = selectedColorInput.dataset.productUrl
  const productJson = await getSelectedProductJson(productUrl || window.location.pathname)

  if (!productJson?.variants) return

  const selectedSizeHandle = handleize(selectedSize)

  const variant = productJson.variants.find((variant) => {
    return variant.options.some((option) => handleize(option) === selectedSizeHandle)
  })

  if (!variant) return

  const mainPrice = document.querySelector('#main-price')
  const compareAtPrice = document.querySelector('#compare-at-price')
  const discountPercentage = document.querySelector('#discount-percentage')

  if (mainPrice) mainPrice.textContent = formatMoney(variant.price)
  if (compareAtPrice) compareAtPrice.textContent = formatMoney(variant.compare_at_price)

  if (discountPercentage && variant.compare_at_price > variant.price) {
    const discount = Math.round(
      ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price,
    )

    discountPercentage.textContent = `-${discount}% OFF`
  }
})